<template>
  <!-- Module -->
  <div>
    <div class="module news-search" :class="loading ? 'module--loading' : ''">
      <div class="module__media bg-primary"></div>
      <div class="module__header">
        <h2>Search</h2>
      </div>
      <div class="module__main">
        <!-- Search Form -->
        <!-- Search Input -->
        <fieldset>
          <cludo-vue-input class="form-control form-control--search" placeholder="Search News...">
            <span class="sr-only">Search</span>
            <i class="icon-search" aria-hidden="true"></i>
          </cludo-vue-input>
        </fieldset>

        <!-- Collapse Toggle -->
        <button type="button" class="button button--small button--block button--toggle toggle toggle--m"
        aria-expanded="false" aria-controls="search-filters" data-toggle="true">
        Filter news
          <span v-if="isFiltering" class="badge bg-white">{{
            filtersCount
          }}</span>
        </button>

        <!-- Collapse -->
        <div id="search-filters" class="collapse collapse--tablet-expanded">
          <div class="collapse__content">
            <!-- Search Checkboxes Filter: News Categories -->
            <cludo-vue-select v-if="showCategoryFilters" :options="formattedNewsCategories"
              placeholder="All news" type="single" :native="true">
              <div class="filter-heading">
                <legend>News categories</legend>
              </div>
            </cludo-vue-select>

            <!-- Search Checkboxes Filter: Year Filter -->
            <template v-if="showDateFilters">
              <cludo-vue-select :options="Years" placeholder="All years" :native="true">
                <div class="filter-heading">
                  <legend>Year</legend>
                </div>
              </cludo-vue-select>

              <!-- Search Checkboxes Filter: Month Filter -->
              <cludo-vue-select :options="Months" placeholder="All months" :disabled="isMonthFilterDisabled" :native="true">
                <div class="filter-heading">
                  <legend>Month</legend>
                </div>
              </cludo-vue-select>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="RHColumn" class="module">
      <div class="module__media bg-dark-blue"></div>
      <div class="module__main news-display__rhColumn" v-html="RHColumn"></div>
    </div> -->
    <div class="rh-column rh-column--desktop" v-if="RHColumn" v-html="RHColumn"></div>
  </div>
</template>

<script>
export default {
  props: {
    RHColumn: {
      type: String,
      default: '',
    },
    filterParamaters: {
      type: Object,
      default: () => { },
    },
    isFiltering: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showCategoryFilters: {
      type: Boolean,
      default: true,
    },
    showDateFilters: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      newsCategories: [
        {
          name: 'Alumni',
          value: 'Alumni',
        },
        {
          name: 'Announcements',
          value: 'Announcements',
        },
        {
          name: 'Business and Enterprise',
          value: 'Business and Enterprise',
        },
        {
          name: 'Current students',
          value: 'Current students',
        },
        {
          name: 'Grants and Awards',
          value: 'Grants and Awards',
        },
        {
          name: 'Health',
          value: 'Health',
        },
        {
          name: 'International',
          value: 'International',
        },
        {
          name: 'Obituaries',
          value: 'Obituaries',
        },
        {
          name: 'Postgraduate',
          value: 'Postgraduate',
        },
        {
          name: 'Public engagement',
          value: 'Public engagement',
        },
        {
          name: 'Publications',
          value: 'Publications',
        },
        {
          name: 'Research',
          value: 'Research',
        },
        {
          name: 'Staff notices',
          value: 'Staff notices',
        },
        {
          name: 'Student life',
          value: 'Student life',
        },
        {
          name: 'Student notices',
          value: 'Student notices',
        },
        {
          name: 'Sustainability',
          value: 'Sustainability',
        },
        {
          name: 'Undergraduate',
          value: 'Undergraduate',
        },
      ],
    };
  },
  computed: {
    formattedNewsCategories() {
      return this.newsCategories.map(category => ({
        label: category.name, // Assuming 'label' is expected by cludo-vue-check-boxes
        value: category.value,
        name: category.name,
        field: 'NewsCategory',
      }));
    },
    filtersCount() {
      const searchFilterCount =
        this.filterParamaters?.searchFilter?.length ?? 0;
      const sortFilterCount = this.filterParamaters?.sortFilter?.length ?? 0;
      const rangeFilterCount =
        Object.keys(this.filterParamaters?.rangeFilter)?.length ?? 0;
      const checkboxFilterCount =
        this.filterParamaters?.checkboxFilter.filter(
          (el) => el.checked === true
        ).length ?? 0;
      const count =
        searchFilterCount +
        sortFilterCount +
        rangeFilterCount +
        checkboxFilterCount;
      return count;
    },
    // Generate an array of years from current year to the year 2000
    Years() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear; year >= 2000; year--) {
        years.push({
          label: year.toString(),
          value: year.toString(),
          name: year.toString(),
          field: 'Year',
        });
      }
      return years;
    },
    // Generate an array of months
    Months() {
      const months = [
        { label: 'January', value: 'January', name: 'January', field: 'Month' },
        { label: 'February', value: 'February', name: 'February', field: 'Month' },
        { label: 'March', value: 'March', name: 'March', field: 'Month' },
        { label: 'April', value: 'April', name: 'April', field: 'Month' },
        { label: 'May', value: 'May', name: 'May', field: 'Month' },
        { label: 'June', value: 'June', name: 'June', field: 'Month' },
        { label: 'July', value: 'July', name: 'July', field: 'Month' },
        { label: 'August', value: 'August', name: 'August', field: 'Month' },
        { label: 'September', value: 'September', name: 'September', field: 'Month' },
        { label: 'October', value: 'October', name: 'October', field: 'Month' },
        { label: 'November', value: 'November', name: 'November', field: 'Month' },
        { label: 'December', value: 'December', name: 'December', field: 'Month' },
      ];
      return months;
    },

    //Disable Month filter if Year filter is not selected
    isMonthFilterDisabled() {
      return !this.filterParamaters?.checkboxFilter?.some(
        (el) => el.field === 'Year' && el.checked === true
      );
    },
  },
  watch: {
    'filterParamaters.checkboxFilter': {
      handler(newVal) {
        // Check if any year is selected
        const isYearSelected = newVal?.some(
          (el) => el.field === 'Year' && el.checked === true
        );

        // If no year is selected, uncheck all months
        if (!isYearSelected) {
          const monthsToUncheck = newVal?.filter(
            (el) => el.field === 'Month' && el.checked === true
          );

          // Uncheck each month
          monthsToUncheck?.forEach((month) => {
            month.checked = false;
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.module {
  &__main {
    fieldset {
      padding: 0;
      border: none;
      width: 100%;
    }

    .form-control--input {

      input,
      label {
        cursor: pointer;
      }
    }
  }
}
</style>
